import React from 'react';

import TextField from 'material-ui/TextField';
import { FormControl, FormHelperText } from 'material-ui/Form';

const errorText = {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
};

const renderTextArea = ({ input, label, className, divClassName, password, disabled, rows, rowsMax, meta: { touched, error }, ...custom }) => (
    <FormControl className={divClassName}>
        <TextField
            label={label}
            error={(error && error !== '')}
            multiline
            rows={rows}
            rowsMax={rowsMax}
            disabled={disabled}
            className={className}
            {...input}
            {...custom}
        />
        {
            error &&
            <FormHelperText style={errorText}>{error}</FormHelperText>
        }
    </FormControl>
);

export default renderTextArea;


// WEBPACK FOOTER //
// ./src/helpers/RenderTextArea.js